import { appendHelpers } from '../helpers/helpers_manager'

const moduleName = '.previews'

export default ({
  repository,
  clientWrapper,
  context
}) => ({
  item: (id) => {
    context.lastApiPath = `${moduleName}.item`
    const helpers = ['issue', 'status', 'revision', 'images', 'rects']

    return clientWrapper.api.get(`/previews/single_show/${id}`)
      .then(({ data }) => data.attributes)
      .then(publication => appendHelpers(publication, repository, helpers))
  },

  issueResources: (issueId) => {
    context.lastApiPath = `${moduleName}.issueResources`
    const helpers = ['issue', 'status', 'revision', 'images', 'rects']

    return clientWrapper.api.get(`/previews/issue_show/${issueId}`)
      .then(({ data }) => data.map(item => item.attributes))
      .then(resources => resources.map(res => appendHelpers(res, repository, helpers)))
  }
})